import { render } from "./levelController.vue?vue&type=template&id=f5dec9fa&scoped=true"
import script from "./levelController.vue?vue&type=script&lang=js"
export * from "./levelController.vue?vue&type=script&lang=js"

import "./levelController.vue?vue&type=style&index=0&id=f5dec9fa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5dec9fa"]])

export default __exports__